export const whatsappTranslations = {
  en: {
    title: 'WhatsApp',
    description: 'Manage WhatsApp conversations',
    notConfigured: {
      title: 'WhatsApp Not Configured',
      description: 'Please configure WhatsApp integration before using WhatsApp.'
    },
    chat: {
      selectChat: 'Select a chat to start messaging',
      inputPlaceholder: 'Type a message...',
      send: 'Send',
      messageStatuses: {
        sent: 'Sent',
        delivered: 'Delivered',
        read: 'Read'
      },
      media: {
        attachMedia: 'Attach media',
        image: 'Image',
        video: 'Video',
        document: 'Document',
        audio: 'Audio',
        voice: 'Voice Message',
        file: 'File',
        viewFullSize: 'View Full Size',
        download: 'Download',
        caption: 'Write a message to send with this {mediaType}...',
        recording: 'Recording...',
        stop: 'Stop',
        play: 'Play',
        readyToSend: 'Ready to send',
        sending: 'Sending...',
        drop: {
          title: 'Drop file to send',
          maxSize: 'Max size: 25MB'
        },
        errors: {
          sizeExceeded: 'File size exceeds the 25MB limit allowed by WhatsApp',
          notImage: 'Selected file is not an image',
          notVideo: 'Selected file is not a video',
          micPermission: 'Microphone permission is required for voice recording',
          sendFailed: 'Failed to send {mediaType}: {error}',
          recordingFailed: 'Could not access microphone. Please check browser permissions.',
          recordingStopped: 'Voice message recording stopped (3 minute limit reached)'
        }
      },
      info: {
        title: 'Chat Information',
        basicInfo: 'Basic Information',
        name: 'Name:',
        chatId: 'Chat ID:',
        number: 'Number:',
        type: 'Type:',
        archived: 'Archived:',
        unreadCount: 'Unread messages:',
        group: 'Group',
        individual: 'Individual Chat',
        yes: 'Yes',
        no: 'No',
        groupInfo: 'Group Information',
        groupName: 'Group Name:',
        creationDate: 'Creation Date:',
        participants: 'Participants:',
        participantsList: 'Participants List:',
        lastMessage: 'Last Message',
        messageId: 'Message ID:',
        content: 'Content:',
        time: 'Time:',
        from: 'From:',
        otherProperties: 'Other Properties',
        muted: 'Muted:',
        pinned: 'Pinned:',
        timestamp: 'Timestamp:',
        copyId: 'Copy ID',
        close: 'Close',
        notAvailable: 'Chat information not available',
        errorFetchingInfo: 'Unable to retrieve chat details',
        idCopied: 'ID copied to clipboard!',
        copyFailed: 'Unable to copy ID'
      },
      loading: {
        initial: 'Loading messages...',
        older: 'Loading earlier messages...',
        retry: 'Retry',
        loadMore: 'Load more messages',
        conversationStart: '• Beginning of conversation •'
      },
      errors: {
        loadFailed: 'Unable to load messages',
        noAccess: 'You don\'t have access to WhatsApp. Contact the administrator to request access.',
        notConfigured: 'WhatsApp is not configured. Contact the administrator to activate this feature.',
        connectionFailed: 'Unable to connect to WhatsApp server',
        checkConnection: 'Check your Internet connection or contact the administrator if the problem persists.',
        timeout: 'Connection to WhatsApp server timed out',
        serverNotResponding: 'The server is not responding. Try again later or contact the administrator.',
        sendFailed: 'Failed to send message'
      }
    },
    search: {
      placeholder: 'Search chats...'
    }
  },
  it: {
    title: 'WhatsApp',
    description: 'Gestisci le conversazioni WhatsApp',
    notConfigured: {
      title: 'WhatsApp Non Configurato',
      description: 'Configura l\'integrazione WAHA in Impostazioni → API e Integrazioni prima di utilizzare WhatsApp.'
    },
    chat: {
      selectChat: 'Seleziona una chat per iniziare a messaggiare',
      inputPlaceholder: 'Scrivi un messaggio...',
      send: 'Invia',
      messageStatuses: {
        sent: 'Inviato',
        delivered: 'Consegnato',
        read: 'Letto'
      },
      media: {
        attachMedia: 'Allega media',
        image: 'Immagine',
        video: 'Video',
        document: 'Documento',
        audio: 'Audio',
        voice: 'Messaggio vocale',
        file: 'File',
        viewFullSize: 'Visualizza a schermo intero',
        download: 'Scarica',
        caption: 'Scrivi un messaggio da inviare con questo {mediaType}...',
        recording: 'Registrazione in corso...',
        stop: 'Ferma',
        play: 'Riproduci',
        readyToSend: 'Pronto per l\'invio',
        sending: 'Invio in corso...',
        drop: {
          title: 'Rilascia il file per inviarlo',
          maxSize: 'Dimensione massima: 25MB'
        },
        errors: {
          sizeExceeded: 'La dimensione del file supera il limite di 25MB consentito da WhatsApp',
          notImage: 'Il file selezionato non è un\'immagine',
          notVideo: 'Il file selezionato non è un video',
          micPermission: 'È necessaria l\'autorizzazione del microfono per registrare messaggi vocali',
          sendFailed: 'Impossibile inviare {mediaType}: {error}',
          recordingFailed: 'Impossibile accedere al microfono. Verifica le autorizzazioni del browser.',
          recordingStopped: 'Registrazione del messaggio vocale interrotta (raggiunto il limite di 3 minuti)'
        }
      },
      info: {
        title: 'Informazioni Chat',
        basicInfo: 'Informazioni di Base',
        name: 'Nome:',
        chatId: 'ID Chat:',
        number: 'Numero:',
        type: 'Tipo:',
        archived: 'Archiviata:',
        unreadCount: 'Messaggi non letti:',
        group: 'Gruppo',
        individual: 'Chat Individuale',
        yes: 'Sì',
        no: 'No',
        groupInfo: 'Informazioni Gruppo',
        groupName: 'Nome Gruppo:',
        creationDate: 'Data Creazione:',
        participants: 'Partecipanti:',
        participantsList: 'Elenco Partecipanti:',
        lastMessage: 'Ultimo Messaggio',
        messageId: 'ID Messaggio:',
        content: 'Contenuto:',
        time: 'Orario:',
        from: 'Da:',
        otherProperties: 'Altre Proprietà',
        muted: 'Silenziata:',
        pinned: 'Fissata:',
        timestamp: 'Timestamp:',
        copyId: 'Copia ID',
        close: 'Chiudi',
        notAvailable: 'Informazioni chat non disponibili',
        errorFetchingInfo: 'Impossibile recuperare i dettagli della chat',
        idCopied: 'ID copiato negli appunti!',
        copyFailed: 'Impossibile copiare l\'ID'
      },
      loading: {
        initial: 'Caricamento messaggi...',
        older: 'Caricamento messaggi precedenti...',
        retry: 'Riprova',
        loadMore: 'Carica altri messaggi',
        conversationStart: '• Inizio della conversazione •'
      },
      errors: {
        loadFailed: 'Impossibile caricare i messaggi',
        noAccess: 'Non hai accesso a WhatsApp. Contatta l\'amministratore per richiedere l\'accesso.',
        notConfigured: 'WhatsApp non è configurato. Contatta l\'amministratore per attivare questa funzionalità.',
        connectionFailed: 'Impossibile connettersi al server WhatsApp',
        checkConnection: 'Verifica la tua connessione Internet o contatta l\'amministratore se il problema persiste.',
        timeout: 'La connessione al server WhatsApp è scaduta',
        serverNotResponding: 'Il server non risponde. Riprova più tardi o contatta l\'amministratore.',
        sendFailed: 'Impossibile inviare il messaggio'
      }
    },
    search: {
      placeholder: 'Cerca chat...'
    }
  }
};